import ENDPOINT from 'constants/endPoint';
import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

export default {
  async getPromotionDetail(payload) {
    const { promotionId, placeId } = payload;
    const path = `${ENDPOINT.PROMOTION}/${promotionId}?place=${placeId}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getPromotionList(payload) {
    const params = getParamsFormObject(payload);
    const path = `${ENDPOINT.PROMOTION}${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async createPromotion(payload) {
    const { placeId, promotion } = payload;
    const path = ENDPOINT.CREATE_PROMOTION(placeId);

    await axiosClient.post(path, promotion);
  },

  async editPromotion(payload) {
    const { promotionId, placeId, promotion } = payload;
    const path = `${ENDPOINT.PROMOTION}/${promotionId}?place=${placeId}`;

    await axiosClient.put(path, promotion);
  },

  async endPromotion(payload) {
    const { placeId, promotionId } = payload;
    const path = ENDPOINT.DELETE_PROMOTION(promotionId, placeId);

    await axiosClient.put(path);
  },

  async createPlacePromotion(payload) {
    const path = ENDPOINT.PLACE_PROMOTION;
    await axiosClient.post(path, payload);
  },

  async getPlacePromotionDetail(payload) {
    const { promotionId, placeId } = payload;
    const path = `${ENDPOINT.PLACE_PROMOTION}/${promotionId}?place=${placeId}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async endPlacePromotion(payload) {
    const { promotionId, placeId } = payload;
    const path = `${ENDPOINT.PLACE_PROMOTION}/${promotionId}?place=${placeId}`;

    await axiosClient.delete(path);
  },

  async getPlacePromotionList(payload) {
    const { placeId, ...rest } = payload;
    const params = getParamsFormObject({
      place: placeId,
      ...rest,
    });
    const path = `${ENDPOINT.PLACE_PROMOTION}${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async deletePromotionDiscount(payload) {
    const { promotionId, placeId } = payload;
    const path = `${ENDPOINT.PROMOTION}/${promotionId}?place=${placeId}`;

    await axiosClient.delete(path);
  },

  async getUsableMarketingPromotionList(payload) {
    const { placeId } = payload;
    const path = `${ENDPOINT.USABLE_MARKETING_PROMOTIONS}?place=${placeId}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getUsableMarketingPromotionDetail(payload) {
    const path = `${ENDPOINT.USABLE_MARKETING_PROMOTIONS}/${payload}`;

    const response = await axiosClient.get(path);

    return response.data;
  },
};
